/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-17 15:26:13
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbCommissionRule {
    /**
     * 提成规则列表
     */
    export var GetCommissionRuleList = (): Promise<any> => {
        return Get(`/api/TbCommissionRule/GetCommissionRuleList`, {});
    };
    /**
     * 新增提成规则
     */
    export var PostAddCommissionRule = (body: any): Promise<any> => {
        return Post(`/api/TbCommissionRule/PostAddCommissionRule`, body);
    };
    /**
     * 查询提成规则
     */
    export var GetCommissionRuleById = (body: any): Promise<any> => {
        return Get(`/api/TbCommissionRule/GetCommissionRuleById`, body);
    };
    /**
     * 修改提成规则
     */
    export var PutUpdateCommissionRule = (body: any): Promise<any> => {
        return Put(`/api/TbCommissionRule/PutUpdateCommissionRule`, body);
    };
    /**
     * 删除提成规则
     */
    export var DeleteCommissionRule = (id: any): Promise<any> => {
        return Delete(`/api/TbCommissionRule/DeleteCommissionRule?id=${id}`, {});
    };
    
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbCommissionRule.ts